<template>
  <div class="certdetail">
    <toptitle :title1="titlework" />    

    <section class="provetop">
      <section class="provesec" style="border: none">
        <div>
          <span>姓名</span>
        </div>
        <span class="arrow">{{ certDetailData.name }}</span>
      </section>
      <section class="provesec">
        <div>
          <span>性别</span>
        </div>
        <span class="arrow">{{ certDetailData.sex }}</span>
      </section>
      <section class="provesec">
        <div>
          <span>身份证号</span>
        </div>
        <span class="arrow">{{ certDetailData.nidNum }}</span>
      </section>
      <section class="provesec">
        <div>
          <span>入职日期</span>
        </div>
        <span class="arrow"> {{ certDetailData.hirDate }}</span>
      </section>
      <section class="provesec">
        <div>
          <span>公司</span>
        </div>
        <div class="arrow">
          <van-cell is-link @click="showCompanyPopup">{{ currentCompany }}</van-cell>
          <van-popup v-model="showCompany">
            <van-picker
              title="请选择公司"
              show-toolbar
              :columns="companyList"
              :default-index="currentCompanyIndex"
              @confirm="onConfirmCompany"
              @cancel="onCancelCompany"
            />
          </van-popup>
        </div>
      </section>
      <section class="provesec">
        <div>
          <span>部门</span>
        </div>
        <span class="arrow">{{ certDetailData.deptName }}</span>
      </section>
      <section class="provesec">
        <div>
          <span>职位</span>
        </div>
        <span class="arrow">{{ certDetailData.positionDesc }}</span>
      </section>
      <section class="provesec color">
        <div>
          <span>年收入</span>
        </div>
        <div class="arrow">
          <van-field
            v-model="certDetailData.salary"
            label=""
            placeholder="由HR填写"
            clearable />
        </div>        
      </section>
      <section class="provesec">
        <div>
          <span>申请日期</span>
        </div>
        <span class="arrow">{{ certDetailData.applyData }}</span>
      </section>
      
      <section class="provesec color">
        <div>
          <span>是否打印</span>
        </div>
        <div class="arrow">
          <van-radio-group v-model="certDetailData.printStatus" direction="horizontal">
            <van-radio name="Y">是</van-radio>
            <van-radio name="N">否</van-radio>
          </van-radio-group>
        </div>        
      </section>
    </section>


    <section class="sec-print">
      <div class="sec-print-mask"></div>
      <div class="sec-print-content" ref="secPrintContainer">
      <h3>收入证明</h3>
      <p class="title">
        兹证明
        <u> {{ certDetailData.name }} </u>先生/女士（身份证号码
        <u> {{certDetailData.nidNum}} </u>），自
        <u> {{certDetailData.hirDate | datefmt}} </u>至今在
        <u> {{certDetailData.company}} </u>工作，任职
        <u> {{certDetailData.deptName}} </u>部门
        <u> {{certDetailData.positionDesc}} </u>职位,平均年收入为
        <u> {{certDetailData.salary}} </u>元（税前）。
      </p>

      <p class="title"><span></span>特此证明。</p>
      <p class="bottom"><u> {{certDetailData.company}} </u></p>
      <p class="bottom"><u> {{certDetailData.applyData | datefmt}} </u></p>
      </div>
    </section>



    <div class="button-bt">
      <div @click="submitData">提交</div>
      <div @click="doPrint">保存图片</div>
    </div>

  </div>
</template>
 
<script>
import { Toast } from "vant";
import toptitle from "../../components/toptitle";
import { GetCertPrintDetailApi, CertPrintModifyApi } from "../../request/api";
import * as dd from "dingtalk-jsapi"; // 此方式为整体加载，也可按需进行加载
import dateformat from "@/utils/dateformat";
import isempty from "@/utils/isempty";

import html2canvas from 'html2canvas';

export default {
  data() {
    name: "certdetail";
    return {
      titlework: "证明详情",

      paramData: null,
      certDetailData:null,

      showCompany:false,
      currentCompany:"",
      currentCompanyIndex:0,
      companyList: [],

    };
  },
  methods: {
    showCompanyPopup() {
      console.log(this.companyList);
      if(this.companyList.length <= 0) return;

      this.showCompany = true;
    },
    onConfirmCompany(value, index) {
      this.currentCompany = value;
      
      this.showCompany = false;
    },
    onCancelCompany() {
      this.showCompany = false;
    },

    getTypeText(val){
      if(!val) return "证明详情";
      if(val.toLowerCase()=== "onjob") return "在职证明详情";
      if(val.toLowerCase() === "income") return "收入证明详情";
    },

    submitData(){
      if(!this.certDetailData.salary) {
         this.$toast("请填写薪资。");
        return false;
      }

      let prms = this.certDetailData;

      CertPrintModifyApi(prms).then((res)=>{
        if (res.data.code == 200) { 
          this.$toast("保存成功");
        }
        else {
          this.$toast("保存失败");
        }
      });

    },
    doPrint(){
      html2canvas(this.$refs.secPrintContainer, { useCORS: true }).then(canvas =>{
        console.log(canvas, "canvas");

        let dataURL = canvas.toDataURL("image/png");
        
        let linkItem = document.createElement("a");
        linkItem.href = dataURL;
        linkItem.setAttribute("download", "收入证明_" + this.certDetailData.name + "_" + this.certDetailData.EMPLID + ".png");
        linkItem.style.display = "none";
        document.body.appendChild(linkItem);
        linkItem.click();
      });
    }
  },
  filters: {
    datefmt(val) {
      if (!val) return "";
      return dateformat("yyyy年MM月dd日", new Date(val));
    },
    dayfmt(val) {
      //用于计算异常的时长（按8小时计算）
      let dayMinutes = 8 * 60.0;

      if (!val) return "";
      return new Number(parseInt(val) / dayMinutes).toFixed(1);
    },
  },
  components: {
    toptitle,
  },
  created() {
    
    if(this.$route.query) {
      this.paramData = this.$route.query;
      this.titlework = this.getTypeText(this.paramData.applyType);
      this.currentCompany = this.paramData.company;
      this.certDetailData = this.paramData;

      let prms = {
        params:{
          cerInfoId: this.paramData.certid
        }
      };

      GetCertPrintDetailApi(prms).then((res) => {

        if (res.code == 200) {

          this.certDetailData = res.data;

          let arr = this.certDetailData.companyDesc;
          this.companyList = arr.map((item, index) => {
            let companyName = item.DESC;
            
            //给 picker 设定初始选中项
            if(companyName == this.currentCompany) this.currentCompanyIndex = index;

            return companyName;
          });
          
        }
      });

    }
    
  },
};
</script>
 
<style lang = "less" scoped>
.provetop {
  background: white;
  margin: 10px 0px;
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  .provesec {
    margin-left: 20px;
    display: flex;
    line-height: 44px;
    border-top: 1px solid #e5e5e5;
    div {
      img {
        height: 15px;
        width: 15px;
        margin-right: 10px;
      }
    }
    .arrow {
      flex: 1;
      text-align: right;
      margin-right: 20px;
      line-height: 44px;
      color: #c4c4c6;
    }
  }
}

/*图片生成相关，使用遮罩层将画布盖起来*/
.sec-print {
  width:1px;
  height:1px;
  overflow:hidden;
  position:relative;
  .sec-print-mask {
    width:1px;
    height:1px;
    background-color:white;
  }
  .sec-print-content {
    z-index:-1;
    position:absolute;
    top:0px;
    left:0px;
    width:640px;
    height:300px;
    background-color:white;
    padding-top:40px;
    padding-left:40px;
    padding-right:40px;
    h3{
      text-align: center;
      margin-bottom:60px;
    }
    p{
      line-height:24px;    
    }
    p.title {
      text-indent: 2em;
    }
    p.bottom{
      text-align: right;
    }
  }
}
.submit {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 44px;
  background: #733e2a;
  color: white;
  line-height: 44px;
  text-align: center;
  font-size: 18px;
}
/deep/ .van-cell__value {
  text-align: right;
}
/deep/ .van-field__control {
  text-align: right;
}
/deep/ .van-popup {
  width: 80%;
}
/deep/.van-cell {
  padding-right: 0px;
}
/deep/ .van-radio-group--horizontal {
  height:44px;
  float:right;
}
.button-bt {
  position: fixed;
  bottom: 0;
  display: flex;
  line-height: 44px;
  text-align: center;
  color: white;
  width: 100%;
  div {
    background: #733e2a;
    width: 50%;
    font-size: 17px;
  }
}
</style>